import { render, staticRenderFns } from "./updatePassword.vue?vue&type=template&id=e8faf2a8"
import script from "./updatePassword.vue?vue&type=script&lang=js"
export * from "./updatePassword.vue?vue&type=script&lang=js"
import style0 from "./updatePassword.vue?vue&type=style&index=0&id=e8faf2a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports